export default __webpack_public_path__ + "static/media/check-circle.bf557117.svg";